import { render, staticRenderFns } from "./Menubar.vue?vue&type=template&id=e89b7364&scoped=true&lang=html&"
import script from "./Menubar.vue?vue&type=script&lang=js&"
export * from "./Menubar.vue?vue&type=script&lang=js&"
import style0 from "./Menubar.vue?vue&type=style&index=0&id=e89b7364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89b7364",
  null
  
)

export default component.exports